import React from 'react'

import Drawer from "@mui/material/Drawer";

const SideDrawerForm = ({ drawer, setDrawer, children }) => {
  return (
    <div>
    <Drawer sx={{zIndex:"1400"}} anchor={"right"} open={drawer} onClose={() => setDrawer()}>
        <div style={{ width: 536 }}>{children}</div>
      </Drawer>
    </div>
  )
}

export default SideDrawerForm